export const previewText = (text: string, n = 40): string => {
  if (text.length > n) {
    return `${text.substring(0, n)} ...`;
  } else {
    return text;
  }
};
